// extracted by mini-css-extract-plugin
export var button = "banner-module--button--319fe";
export var main = "banner-module--main--d35ad";
export var margin = "banner-module--margin--6dbcc";
export var rootTitle = "banner-module--rootTitle--0ef51";
export var subtitle = "banner-module--subtitle--0c047";
export var title = "banner-module--title--7a862";
export var titleContainer = "banner-module--titleContainer--d52a0";
export var typobutton = "banner-module--typobutton--c5c2c";